import homeLogo from "./imgs/home_logo.webp";
import homeWhitePaper from "./imgs/home_gitbook.png";
import homeFb from "./imgs/hoem_discord.png";
import homeTwiier from "./imgs/home_twiier.png";
import homeGitHub from './imgs/home_github.png';
import homeYoutube from './imgs/home_youtube.png';
import navme from "./imgs/nav_menu.webp";
import navWallet from "./imgs/nav-wallet.webp"
import WalletAddressImg from './imgs/wallet_info_address.png'
import walletAddressCopy from './imgs/wallet_info_address_copy.png'
import WalletLogOut from './imgs/wallet_info_logout.png'
import walletNext from './imgs/wallet_info_next.png'
import "./App.scss";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useConnect, useDialog } from "@connect2ic/react";
import { getAccountId } from './utils/Utils'
import { Principal } from "@dfinity/principal"
import { alertObj } from "./CommonUtil"


function copyToClipboard(text) {

 
  var textField = document.createElement('textarea')
  textField.innerText = text
  document.body.appendChild(textField)
  textField.select()
  document.execCommand('copy')
  textField.remove()

}

function App() {


  const { t } = useTranslation();
  const { isConnected, principal } = useConnect({
    onConnect: () => {

      walletAddress = principal
   

      document.getElementById('walletInfoButton').removeAttribute('disabled')
    },
    onDisconnect: () => { },
  });
  const dialog = useDialog();
  var connectWalletContent = isConnected === true ? substractAddress(principal) : t("Connect Wallet");
  var walletAddress = isConnected === true ? accountId(principal) : ""
  function connectWallet() {
    if (!isConnected && !dialog.isOpen) {
      dialog.open();
      
    }
  }

  function accountId(principalStr) {

    let principal = Principal.fromText(principalStr)
    return getAccountId(principal)
  }
  function substractAddress(principal) {

    
    let aId = accountId(principal)

   

    let addressLength = aId.length
    return aId.substr(0, 4) + "..." + aId.substr(addressLength - 4)

  }

  const divStr = "div-connect-wallet-bg dropdown"

  function WalletInfo() {
    return (

      <div className="dropdown-menu dropdown-menu-end wallet-info-bg" >
        <div className="wallet-info-arrow"></div>
        <div>
          <div className="d-flex align-items-center wallet-info-cell-div">
            <img className="wallet-info_address_img" src={WalletAddressImg}></img>
            <span className="wallet-info-address-span">{walletAddress}</span>
            <img className="wallet-info-address-copy-img" src={walletAddressCopy} onClick={() => {

              let content = accountId(principal)

              copyToClipboard(content)
              alertObj.show(t('Copy successfully'), 0)


            }} />
            <div className="line"></div>
          </div>
          <div className="d-flex align-items-center wallet-info-logout-div" onClick={() => {
            localStorage.removeItem("ic-delegation")
            window.location.reload()
          }}>
            <img className="wallet-info_address_img" src={WalletLogOut}></img>
            <span className="wallet-info-address-span">{t('Log out')}</span>
          </div>

        </div>
      </div>
    )
  }

  return (
    <div className="" style={{ marginBottom: 40 }}>
      <div className="navigation" >
        <nav className=" navbar navbar-expand-sm fixed-top border-bottom" id="appNavigation" style={{ background: "#FFFCF7" }} >
          <div className="container">
            <img
              className="home-logo"
              src={homeLogo}
              alt="HomeLogo"
              onClick={() => {
                window.location.href = "/";
              }}
            />
            <div className={document.body.scrollWidth >= 576 ? divStr : "div-connect-wallet-bg"}>
              <div className="d-flex  justify-content-center align-items-center  div-connect-wallet" onClick={connectWallet} >

                <img className="img-wallet" src={navWallet} alt="wallet" />
                <span className="span-address">{connectWalletContent}</span>
                <img className="img-next" src={walletNext} />
                <button type="button" className="btn wallet-info-but" id="walletInfoButton" data-bs-toggle="dropdown" data-bs-auto-close="outside" disabled></button>
                <WalletInfo ></WalletInfo>
              </div>
            </div>
            <button className="btn navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar" >
              <img src={navme} style={{ width: '40px', height: '40px' }} />
            </button>

            {/* <img
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsibleNavbar"
              aria-controls="navbarNavDropdown"
              aria-expanded="false"
              aria-label="Toggle navigation"
              style={{
                padding: 0,
                border: 0,
                width: '40px',
                height: '40px',
              }}
              src={navme}
              alt="nav icon"
            /> */}
            <div
              className="collapse navbar-collapse"
              id="collapsibleNavbar"
              style={{ flexGrow: "unset" }}
            >
              <ul className="navbar-nav">
                <li className="navbar-item">
                  <a
                    className="nav-link"
                    href="https://worker-decentralize-network.gitbook.io/white-paper/"
                    target="_blank"
                  >
                    <img
                      className="home-icon"
                      src={homeWhitePaper}
                      alt="WhitePaper"
                    />
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="https://discord.gg/sK4bcFSW3C"
                    target="_blank"
                  >
                    <img className="home-icon" src={homeFb} alt="fackbook" />
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="https://twitter.com/WDN_Protocol"
                    target="_blank"
                  >
                    <img className="home-icon" src={homeTwiier} alt="twitter" />
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="https://github.com/WDNProtocol"
                    target="_blank"
                  >
                    <img className="home-icon" src={homeGitHub} alt="github" />
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    className="nav-link"
                    href="https://youtu.be/iJViwiLJnvw"
                    target="_blank"
                  >
                    <img className="home-icon" src={homeYoutube} alt="youtube" />
                  </a>
                </li>

              </ul>
            </div>
          </div>
        </nav>
      </div>
      <div  style={{ marginTop: 80 }}>
        <Outlet context={{ isConnected: isConnected, connectWallet: connectWallet }} />
      </div>
    </div>
  );
}

export default App;
